import React, { useContext, useEffect, useState } from "react";
import NewButton from "../../../NewComponents/NewButton";
import { languages } from "../../../Data/languages";
import {
  formatTotal,
  getDiscount,
  getExpedited,
  getHardCopyPrice,
  getOrderPageCountTotal,
  getTotal,
} from "../../../Data/Functions";
import { FormTextInput } from "../../../Components/FormTextInput";
import { NotificationContext } from "../../../Context/NotificationContext";
import "./QuoteSummary.css";
import { firestore } from "../../../firebase.config";
import { DataContext } from "../../../Context/DataContext";

const QuoteSummary = ({ languageFrom, languageTo, quote, windowSize }) => {
  const { showNotification } = useContext(NotificationContext);
  const { userData, teamData } = useContext(DataContext);

  const [pagesCount, setPagesCount] = useState("");
  const [discount, setDiscount] = useState(0);
  // const [expeditedServiceOption, setExpeditedServiceOption] = useState("paid");
  const [isCompleting, setIsCompleting] = useState(false);

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  useEffect(() => {
    if (quote && quote.pagesCount) {
      setPagesCount(quote.pagesCount);
    }
    if(quote && quote.discount){
      setDiscount(quote.discount)
    }
  }, [quote, pagesCount, discount]);

  
  //  useEffect(() => {
  //     if (quote.teamId) {
  //       firestore.collection("teams").doc(quote.teamId).get().then(doc =>{
  //         if(doc.exists){
  //           setDiscount(quote ? quote.discount || 0 : 0);
  //           setExpeditedServiceOption(doc.data().expeditedServices || "paid");
  //         }
  //       })
  //     }
  
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [userData, teamData]);


  const onChangePagesCount = (count) => {
    const reg = /^[0-9]+\.?[0-9]{0,3}$/;
    if (count === "" || reg.test(count)) {
      const updatedCount = count === "" ? "0" : count;
      setPagesCount(updatedCount);
    }
  };

  const getServicesTotal = () => {
    return (
      0 +
      (quote.notarization ? 34.9 : 0) +
      (quote.expeditedPlus || quote.expedited
        ? getExpedited(quote, pagesCount)
        : 0) +
      (quote.hardCopy
        ? getHardCopyPrice(
          quote.hardCopyExtra.country,
          quote.hardCopyExtra.method,
          quote.hardCopyExtra.requireSignature,
          quote
        )
        : 0)
    );
  };

  const handleCompleteQuote = async () => {
    if (quote.status === "ordered") {
      showNotification(
        "Info",
        "This quote has already been completed.",
        "info"
      );
      return;
    }

    try {
      await firestore
        .collection("quotes")
        .doc(quote.id)
        .update({
          pagesCount: pagesCount,
          discount: discount,
          totalPrice: getTotal(quote, pagesCount, quote.certified) - getDiscount(quote, pagesCount, discount),
          status: "replied",
        });

      showNotification(
        "Success",
        "Quote has been successfully completed.",
        "success"
      );

      // Optimistically update the UI
      setIsCompleting(true);
    } catch (error) {
      console.error("Error completing the quote:", error);
      showNotification(
        "Error",
        "Failed to complete the quote. Try again.",
        "error"
      );
    }
  };

  return (
    <>
      <div className="orderSummary">
        <h2 className="orderSummaryTitle">Quote Summary</h2>
        <div className="quoteSummaryData">
          <FormTextInput
            placeholder={"Page Count"}
            value={pagesCount === "0" ? "" : pagesCount}
            onChange={onChangePagesCount}
            disabled={quote.status === "ordered" || isCompleting}
          />

          <div className="flex gap-2 flex-row lg:flex-col 2xl:flex-row">
            <FormTextInput
              placeholder={"Discount"}
              value={discount}
              disabled={quote.status === "ordered" || isCompleting}
              onChange={setDiscount}
            />
            {/* <NewButton
              text={"Apply"}
              back={true}
              icon={false}
              disabled={isCompleting}
              width={
                windowSize.width > 1536
                  ? "100px"
                  : windowSize.width < 1024
                    ? "100px"
                    : "100%"
              }
              onClick={() => handleApplyCode()}
              whiteBtn={true}
            /> */}
          </div>
        </div>

        <div className="orderSummaryInfoWrapper mt-4">
          <div className="orderSummaryInfo">
            <h4 className="orderSummaryInfoType">Certified Translation</h4>
            <h4 className="orderSummaryInfoType">
              {pagesCount !== ""
                ? "$" +
                getOrderPageCountTotal(quote, pagesCount, quote.certified).toFixed(
                    2
                  )
                : "$0.00"}
            </h4>
          </div>
          <p className="orderSummaryInfoCount">
            {pagesCount !== ""
              ? pagesCount +
              " pages (" +
              parseInt(pagesCount, 10) * 250 +
              " words max)"
              : "0 pages (0 words max)"}
          </p>
          {languageFrom && languageTo && (
            <p className="orderSummaryInfoCount">
              {getLanguage(languageFrom)} to {getLanguage(languageTo)}
            </p>
          )}
        </div>

        {quote.notarization ||
          quote.expedited ||
          quote.expeditedPlus ||
          (quote.hardCopy &&
            quote.hardCopyExtra.country !== "" &&
            quote.hardCopyExtra.method !== "") ||
          (quote.hardCopy && quote.hardCopyExtra.requireSignature) ? (
          <div className="orderSummaryInfoWrapper">
            <div className="orderSummaryInfo">
              <h4 className="orderSummaryInfoType">Services</h4>
              <h4 className="orderSummaryInfoType">
                {pagesCount !== ""
                  ? "" + formatTotal(getServicesTotal())
                  : "$0.00"}
              </h4>
            </div>
           {quote.notarization && <div className="orderSummaryInfo">
              <p className="orderSummaryInfoCount">Notarization</p>
              <p className="orderSummaryInfoCount">
                "$34.90"
              </p>
            </div>}
            {(quote.expedited || quote.expeditedPlus) && <div className="orderSummaryInfo">
              <p className="orderSummaryInfoCount">
                {quote.expeditedPlus ? "Expedited+" : "Expedited"} Turnaround
              </p>
              <p className="orderSummaryInfoCount">
                {pagesCount !== ""
                  ? formatTotal(
                        getExpedited(
                          quote,
                          pagesCount,
                          false,
                          false,
                          quote.certified
                        )
                      )
                  : "$0.00"}
              </p>
            </div>}
            {quote.hardCopy &&
              quote.hardCopyExtra.country !== "" &&
              quote.hardCopyExtra.method !== ""
              && <div className="orderSummaryInfo">
              <p className="orderSummaryInfoCount">Mail Hard Copy</p>
              <p className="orderSummaryInfoCount">
                {`$${
                      [
                        "United States",
                        "Puerto Rico",
                        "U.S. Virgin Islands",
                      ].includes(quote.hardCopyExtra.country)
                        ? quote.hardCopyExtra.method === "priority"
                          ? "19.95"
                          : "37.95"
                        : quote.hardCopyExtra.method === "priority"
                        ? "49.95"
                        : "78.95"
                    }`}
              </p>
            </div>}
            {quote.hardCopy && quote.hardCopyExtra.requireSignature && <div className="orderSummaryInfo">
              <p className="orderSummaryInfoCount">
                Signature Required for Delivery
              </p>
              <p className="orderSummaryInfoCount">$4.99
              </p>
            </div>}
          </div>
        ) : (
          <div className="orderSummaryInfoWrapper">
            <div className="orderSummaryInfo">
              <h4 className="orderSummaryInfoType">Services</h4>
              <h4 className="orderSummaryInfoType">$0.00</h4>
            </div>
          </div>
        )}
        {discount && discount > 0 ? (
          <div className="orderSummaryInfo">
            <h4 className="orderSummaryInfoType">Discount {discount}%</h4>
            <h4 className="orderSummaryInfoType">
              - {formatTotal(pagesCount !== "" ? getDiscount(quote, pagesCount, discount) : 0)}
            </h4>
          </div>
        ) : (
          ""
        )}
        <div className="orderSummaryTotal">
          <h4>Total</h4>
          <h4>{formatTotal(pagesCount !== "" ? getTotal(quote, pagesCount, quote.certified) - getDiscount(quote, pagesCount, discount) : 0)}</h4>
        </div>
        {quote.status !== "cancelled" && (
          <div className="queteSummary">
            <p className="quotesButtonDiscription">
              After clicking "Complete" the quote price can’t be changed and
              will be sent to the client
            </p>
          </div>
        )}
        {quote.status !== "cancelled" && (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              padding: "12px",
              marginTop: "1rem",
              backgroundColor:
                quote.status === "ordered" || isCompleting
                  ? "#B3E4EB"
                  : "#12ABBF",
              cursor:
                quote.status === "ordered" || isCompleting
                  ? "not-allowed"
                  : "pointer",
              opacity: isCompleting ? 0.6 : 1,
            }}
            onClick={() => {
              const pageCountNum = parseFloat(pagesCount);
              if (
                !isCompleting &&
                quote.status !== "ordered" &&
                pageCountNum > 0
              ) {
                handleCompleteQuote();
              } else {
                showNotification("Error", "Page count must be greater than 0 to complete the quote.", "error");
              }
            }}

          >
            <p className="completeQuotesButton">Complete Quote</p>
          </div>
        )}
      </div>
    </>
  );
};

export default QuoteSummary;
